import React, { useEffect, useState } from "react";
import ValetReceiptDetails from "../../ValetReceipt/ValetReceiptDetails";
import { useEnqueueSnackbar } from "../../../hooks/useEnqueueSnackbar";
import ValetInventoryService from "../../../services/ValetInventoryService";
import apiClient from "../../../auth/apiClient";


const ValetPaymentSummary = ({ credentialId }) => {
    const enqueueSnackbar = useEnqueueSnackbar();
    const [parkingActivityId, setparkingActivityId] = useState(null);
    const valetinventoryService = new ValetInventoryService(apiClient);

    const getTransactionData = async () => {
        try {
            var response = await valetinventoryService.getValetTransactionHistory(credentialId);
            const tansactionData = response.data;
            if (tansactionData != null) {
                const paymentData = tansactionData.filter(item => item.activityDescription.toLowerCase() === "payment");
                setparkingActivityId(paymentData[0]?.parkingActivityID);
            }
        } catch (ex) {
            enqueueSnackbar("Failed to load transaction data", {
                variant: "error",
                tag: "FailedToLoadTransactionData",
            });
        }
    };

    useEffect(() => {
        if (credentialId) {
            getTransactionData();
        }
    }, [credentialId])

    return (
        <div >
            <>
                {parkingActivityId && (
                    <ValetReceiptDetails
                        parkingActivityId={parkingActivityId}
                        showReceiptHeaderFooter={false}
                    ></ValetReceiptDetails>
                )}
            </>
        </div>
    );
};

export default ValetPaymentSummary;